import React from 'react';
import Icon from '../../../components/AppIcon';

const ImpactMetricsCard = ({ metric, icon, value, label, change, color = "primary" }) => {
  const colorClasses = {
    primary: "hero-gradient",
    secondary: "achievement-gradient", 
    success: "bg-gradient-to-br from-emerald-500 to-emerald-600",
    warning: "bg-gradient-to-br from-amber-500 to-amber-600"
  };

  return (
    <div className="bg-card rounded-xl p-6 card-shadow hover:card-shadow-hover transition-smooth">
      <div className="flex items-center justify-between mb-4">
        <div className={`w-12 h-12 rounded-lg ${colorClasses[color]} flex items-center justify-center`}>
          <Icon name={icon} size={24} className="text-white" />
        </div>
        {change && (
          <div className={`flex items-center text-sm font-medium ${
            change > 0 ? 'text-success' : 'text-error'
          }`}>
            <Icon 
              name={change > 0 ? "TrendingUp" : "TrendingDown"} 
              size={16} 
              className="mr-1" 
            />
            {Math.abs(change)}%
          </div>
        )}
      </div>
      
      <div className="space-y-1">
        <div className="text-3xl font-bold text-foreground animate-count-up">
          {value}
        </div>
        <div className="text-sm text-muted-foreground font-medium">
          {label}
        </div>
      </div>
    </div>
  );
};

export default ImpactMetricsCard;